import CheckboxWidget from "../CheckboxWidget/CheckboxWidget";
import CheckboxesWidget from "../CheckboxesWidget/CheckboxesWidget";
import ColorWidget from "../ColorWidget/ColorWidget";
import DateWidget from "../DateWidget/DateWidget";
import DateTimeWidget from "../DateTimeWidget/DateTimeWidget";
import EmailWidget from "../EmailWidget/EmailWidget";
import PasswordWidget from "../PasswordWidget/PasswordWidget";
import RadioWidget from "../RadioWidget/RadioWidget";
import RangeWidget from "../RangeWidget/RangeWidget";
import SelectWidget from "../SelectWidget/SelectWidget";
import TextareaWidget from "../TextareaWidget/TextareaWidget";
import TextWidget from "../TextWidget/TextWidget";
import UpDownWidget from "../UpDownWidget/UpDownWidget";
import URLWidget from "../URLWidget/URLWidget";
import FileWidget from "../FileWidget/FileWidget";
import SubmitButton from "../SubmitButton/SubmitButton";

export default {
  CheckboxWidget,
  CheckboxesWidget,
  ColorWidget,
  DateWidget,
  DateTimeWidget,
  EmailWidget,
  PasswordWidget,
  RadioWidget,
  RangeWidget,
  SelectWidget,
  TextareaWidget,
  TextWidget,
  UpDownWidget,
  URLWidget,
  FileWidget,
  SubmitButton
};
